import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import AdminVpnProfilesPage from "./ui";

/** VPN profiles (Management menu); shown only when VPN is enabled on the deployment. */
const VpnProfiles = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <AdminVpnProfilesPage />
    </PageContentShell>
  </DashboardLayout>
);

export default VpnProfiles;
